import React from 'react';
import { Dialog } from 'primereact/dialog';
import { DropdownOption } from './types';
import { sanitizeText } from './textInput';

interface Props {
  visible: boolean;
  reasonList: DropdownOption[];
  reason: number | '';
  otherReason: string;
  submitted: boolean;
  isRemoving: boolean;
  onReasonChange: (v: number | '') => void;
  onOtherChange: (v: string) => void;
  onHide: () => void;
  onConfirm: () => void;
}

const Err = () => (
  <span className="form-text text-danger small">Field is required</span>
);

const RemoveStudentDialog: React.FC<Props> = (p) => (
  <Dialog
    header="Remove Student"
    visible={p.visible}
    modal
    draggable={false}
    closeOnEscape={false}
    blockScroll
    style={{ width: '30rem', maxWidth: '95vw' }}
    onHide={p.onHide}
  >
    <div className="mb-3">
      <label className="form-label inMandatory">
        Reason for removing the student
      </label>
      <select
        className="form-select"
        value={p.reason}
        onChange={(e) =>
          p.onReasonChange(e.target.value ? Number(e.target.value) : '')
        }
      >
        <option value="">Please Select</option>
        {p.reasonList.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
      {p.submitted && !p.reason && <Err />}
    </div>

    {p.reason == 7 && (
      <div className="mb-3">
        <label className="form-label inMandatory">Specify the reason</label>
        <textarea
          className="form-control"
          placeholder="Reason in short"
          rows={8}
          maxLength={250}
          value={p.otherReason}
          onChange={(e) => p.onOtherChange(sanitizeText(e.target.value))}
        />
        <div className="form-text small">
          {p.otherReason.length} / 250 characters
        </div>
        {p.submitted && !p.otherReason.trim() && <Err />}
      </div>
    )}

    {/* <p className="text-muted small mb-3">
      The student stays in the PMU master as removed, with this reason against
      the record, and can be restored later.
    </p> */}

    <div className="d-flex justify-content-end gap-2 border-top pt-3">
      <button
        type="button"
        className="btn btn-outline-secondary"
        onClick={p.onHide}
      >
        Cancel
      </button>
      <button
        type="button"
        className="btn btn-danger"
        disabled={p.isRemoving}
        onClick={p.onConfirm}
      >
        Remove student
      </button>
    </div>
  </Dialog>
);

export default RemoveStudentDialog;
